module.exports = __webpack_public_path__ + "c63ef299016ea244ecf82388c08b61ec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/banana-s.png
// module id = 1980
// module chunks = 0